// src/modules/app-views/leads/pages/Init/components/tableColumns/nameColumn.js
import translateX from 'utils/translateX';

function nameColumn(buildColumnProps, options = {}) {
  const {
    key = 'name',
    title = 'name',
    dataIndex = 'name',
    width = 240,
    align = 'left',
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const name = r?.name;
      const interest = r?.interest;
      return (
        <div>
          {name ? <span className="font-weight-bold">{name}</span> : '—'}
          {interest ? <div style={{ fontSize: 12, color: '#888' }}>{interest}</div> : null}
        </div>
      );
    },
  };
}

export default nameColumn;
